import React from "react";
import "./About_Content.css";
import Arrow_Btn from "../../common_components/common_btn/arrow_btn/Arrow_Btn";
import { useNavigate } from "react-router-dom";
import Common_Title from "../../common_components/common_title/Common_Title";

const About_Content = () => {
  const navigate = useNavigate();

  return (
    <section className="about_content_section">
      <div className="container">
        <div className="row">
          <div className="about_content_row">
            {/* Left Image Column */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
              <div className="about_col">
                <div className="img_holder">
                  <img
                    src="/assets/images/home/about_content/group.png"
                    alt="Automotive Services"
                    className="about_image"
                  />
                </div>
              </div>
            </div>

            {/* Text Column */}
            <div className="col-12 col-sm-7 col-md-7 col-lg-8 col-xl-4">
              <div className="about_text_col">
                <div className="about_text">
                  <Common_Title pageTitle="About Us" boxText="Who We Are" />

                  <p className="about_description">
                    Gravity Drive is committed to revolutionizing urban
                    transport by providing fast, safe, and affordable rides
                    along with reliable delivery services. Our user-friendly app
                    connects you with verified drivers and transport partners to
                    ensure a seamless experience every time you book. Whether
                    you need a quick ride across town or a trusted way to send
                    packages, Gravity Drive is here to move you forward with
                    confidence. With a focus on safety, convenience, and
                    transparency, we continuously innovate to meet the evolving
                    needs of our users. Join millions who trust Gravity Drive
                    for their daily transport & delivery needs.
                  </p>
                  <Arrow_Btn
                    btnText={"More About Us"}
                    onClick={() => navigate("/about-us")}
                  />
                </div>
              </div>
            </div>

            {/* Right Image Column */}
            <div className="col-12 col-sm-5 col-md-5 col-lg-4 col-xl-3">
              <div className="about_img_col">
                <div className="about_image_holder">
                  <img
                    src="/assets/images/home/about_content/wash.png"
                    alt="Car Wash"
                    className="car_wash_image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Content;
